import RequestService from "@/configurations/AxiosConfig";

const endpoints = {
  branches: 'branches',
};

const BranchesService = {
  deleteBranch: (id: string | number) => RequestService.delete(`${endpoints.branches}/${id}`),
  getBranchesByCompanyId: (companyId: string | number) =>
    RequestService.get(`${endpoints.branches}/by-company/${companyId}`),
};

export default BranchesService;
